import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import debounce from 'lodash.debounce';
import React, { useState, useEffect, useCallback } from 'react';
import { DEBOUNCE_DELAY_MS } from '../constants';
import { getFullName } from '../utils';

const SearchAutocomplete = ({
  value,
  onValueSelected,
  searchApi,
  className,
  placeholder,
  label,
  required,
  disabled,
  responseKey,
}) => {
  const [searchOptions, setSearchOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const changeHandler = async (value) => {
    const query = await searchApi({ query: value });
    const optionsToSet = query[responseKey] ? query[responseKey] : query;
    setSearchOptions(optionsToSet);
    setLoading(false);
  };

  const debouncedChangeHandler = useCallback(
    debounce(changeHandler, DEBOUNCE_DELAY_MS),
    []
  );

  useEffect(() => {
    if (inputValue === '') {
      setLoading(false);
      setSearchOptions(null);
    } else if (!value && inputValue.length >= 2) {
      setLoading(true);
      debouncedChangeHandler(inputValue);
    }
  }, [inputValue]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      options={searchOptions || []}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        return getFullName(option.User ? option.User : option);
      }}
      value={value}
      onChange={(e, newValue) => {
        if (!newValue) onValueSelected(null);
        onValueSelected(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(e, newValue) => setInputValue(newValue)}
      filterOptions={(options) => options}
      getOptionSelected={(option, value) => option.userId === value.userId}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          label={label}
          variant='outlined'
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading && <CircularProgress color='inherit' size={20} />}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchAutocomplete;
